import { isRouteErrorResponse, useRouteError, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const ErrorPage: React.FC = () => {
  const error: any = useRouteError();
  const navigate = useNavigate();
  const notFound = isRouteErrorResponse(error) && error.status === 404;

  console.error(error);

  return (
    <main className="page-background flex min-h-screen items-center justify-center px-4 py-8">
      <div className="w-full max-w-[440px] text-center">
        <p
          aria-hidden
          className="mb-4 select-none font-mono text-[2.75rem] leading-none text-muted-foreground"
        >
          {'>_<'}
        </p>

        <h1 className="mb-2 font-display text-[1.75rem] font-bold tracking-tight text-foreground sm:text-[2rem]">
          {notFound ? 'This page does not exist.' : 'This page did not load.'}
        </h1>

        <p className="mb-6 text-pretty text-muted-foreground">
          {notFound
            ? 'Check the address, or search for the tool that you want.'
            : 'Reload the page to try again, or search for another tool.'}
        </p>

        {/* An error boundary can render outside Layout, where the tools dialog does not exist. Home holds the same search. */}
        <Button onClick={() => navigate('/')} className="h-11 px-6">
          See All Tools
        </Button>
      </div>
    </main>
  );
};

export default ErrorPage;
